import { makeStyles } from "@material-ui/styles";

const playerListTableStyles = makeStyles(() => ({
	root: {
		width: "100%",
		height: "100%",
		position: "relative",
		flex: "1",
		display: "flex",
		flexDirection: "column"
	},
	icon: {
		color: "#3c537c"
	},
	disabledChkBox: {
		"&.Mui-disabled": {
			color: "gray"
		}
	}
}));

export default playerListTableStyles;
